import { render, staticRenderFns } from "./CargaGradillas.vue?vue&type=template&id=33b88caa&scoped=true&"
import script from "./CargaGradillas.vue?vue&type=script&lang=js&"
export * from "./CargaGradillas.vue?vue&type=script&lang=js&"
import style0 from "./CargaGradillas.vue?vue&type=style&index=0&id=33b88caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b88caa",
  null
  
)

export default component.exports